import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deTranslation from './locales/de.json';
import enTranslation from './locales/en.json';

const resources = {
  de: { translation: deTranslation },
  en: { translation: enTranslation }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Standardsprache ist Deutsch
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false // Nicht notwendig für React
    }
  });

export default i18n;
